import { useEffect, useState } from "react";
import { API } from "../../../services/api";
import { FieldLabel } from "../AdminCommon";
import {
    btnBlackStyle,
    btnOutlineDangerStyle,
    cardStyle,
    cardTitleStyle,
    countBadgeStyle,
    errorStyle,
    fieldStyle,
    inputStyle,
    tableStyle,
    tdStyle,
    thStyle,
} from "../styles/adminDashboardStyles";

export function TourneesTab() {
    const [tournees, setTournees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [name, setName] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [formError, setFormError] = useState(null);

    const fetchTournees = async () => {
        try {
            const { data } = await API.get("/admin/tournees");
            setTournees(data);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchTournees(); }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormError(null);
        setSubmitting(true);
        try {
            const { data } = await API.post("/admin/tournees", { name });
            setTournees(prev => [...prev, data]);
            setName("");
        } catch (err) {
            const status = err.response?.status;
            setFormError(
                status === 409 ? "Une tournée avec ce nom existe déjà." :
                err.response?.data?.message ?? "Erreur lors de la création."
            );
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = async (id) => {
        if (!globalThis.confirm("Supprimer cette tournée ?")) return;
        try {
            await API.delete(`/admin/tournees/${id}`);
            setTournees(prev => prev.filter(t => t.id !== id));
        } catch {
            alert("Erreur lors de la suppression.");
        }
    };

    return (
        <div>
            <div style={cardStyle}>
                <h2 style={cardTitleStyle}>Ajouter une tournée</h2>
                <form onSubmit={handleSubmit} style={{ display: "flex", gap: "14px", alignItems: "flex-end" }}>
                    <div style={fieldStyle}>
                        <FieldLabel required>Nom</FieldLabel>
                        <input id="admin-tournee-name" style={{ ...inputStyle, width: "220px" }} placeholder="14H30" value={name} onChange={e => setName(e.target.value)} required />
                    </div>
                    <button type="submit" disabled={submitting} style={btnBlackStyle}>
                        {submitting ? "Création..." : "Créer"}
                    </button>
                </form>
                {formError && <p style={errorStyle}>{formError}</p>}
            </div>

            <div style={cardStyle}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                    <h2 style={{ ...cardTitleStyle, margin: 0 }}>Tournées</h2>
                    {!loading && <span style={countBadgeStyle}>{tournees.length}</span>}
                </div>
                {loading ? (
                    <p style={{ color: "#9ca3af", fontSize: "14px" }}>Chargement...</p>
                ) : (
                    <table style={tableStyle}>
                        <thead>
                            <tr><th style={thStyle}>Nom</th><th style={thStyle} /></tr>
                        </thead>
                        <tbody>
                            {tournees.length === 0 && (
                                <tr><td colSpan={2} style={{ padding: "20px", textAlign: "center", color: "#9ca3af", fontSize: "14px" }}>Aucune tournée</td></tr>
                            )}
                            {tournees.map(t => (
                                <tr key={t.id} style={{ borderBottom: "1px solid #f3f4f6" }}>
                                    <td style={tdStyle}>
                                        <span style={{ display: "inline-flex", alignItems: "center", gap: "10px" }}>
                                            <span style={{ width: "30px", height: "30px", borderRadius: "8px", background: "#ede9fe", color: "#6c4de6", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "14px", flexShrink: 0 }}>
                                                ⏱
                                            </span>
                                            <span style={{ fontWeight: 500, color: "#111827" }}>{t.name}</span>
                                        </span>
                                    </td>
                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                        <button onClick={() => handleDelete(t.id)} style={btnOutlineDangerStyle}>Supprimer</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
